import PropTypes from 'prop-types';
import AddPhoneModal from '../Connections/AddPhoneModal';
import EventBus from 'eventing-bus';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import PhoneInput from 'react-phone-input-2'
import AppBar from '@material-ui/core/AppBar';
import TextField from '@mui/material/TextField';
import { CircularProgress } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Select, MenuItem, FormControl } from '@mui/material';
import React, { useState, useEffect, useCallback, useRef } from 'react';

import './index.css';
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import PlanAnimation from '../../components/Animations/PlanAnimation.js';

import { getAllAgents } from '../../store/Agent';
import { getAllPhones, createPhone, deletePhone, updatePhone, createOutboundCall, setPhoneId } from '../../store/Phone';

const PhoneNumbers = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const { allAgents } = useSelector(state => state['Agent']);
    const { allPhones, phoneId, phonesLoading: loading } = useSelector(state => state['Phone']);

    const [deleteNumber, setDeleteNumber] = useState('');
    const [selectedPhone, setSelectedPhone] = useState({});

    const [searchAgent, setAgentSearch] = useState('');
    const [filteredAgents, setFilteredAgents] = useState([]);

    const [searchNumber, setNumberSearch] = useState('');
    const [filteredNumbers, setFilteredNumbers] = useState([]);

    const [newForm, setNewForm] = useState({ nickName: '', phoneNumber: '', trunkPassword: '', trunkUsername: '', terminationUri: '', outboundPhone: '' });
    const [openState, setOpenState] = useState({ inboundDropdown: false, outboundDropdown: false, outboundCall: false, isAddNumber: false, buyNumber: false, editAgent: false });

    // Use refs to track initialization
    const initialLoadRef = useRef(false);

    // Define filter functions before useEffects that use them
    const filterAgents = useCallback(() => {
        setFilteredAgents((allAgents || []).filter(status => status['name'].toLowerCase().includes(searchAgent.toLowerCase())))
    }, [allAgents, searchAgent]);

    const filterNumbers = useCallback(() => {
        setFilteredNumbers((allPhones || []).filter(status => status['nickName'].toLowerCase().includes(searchNumber.toLowerCase())))
    }, [allPhones, searchNumber]);

    // Initialize data on mount
    useEffect(() => {
        if (!initialLoadRef.current) {
            initialLoadRef.current = true;

            // Only fetch if data is empty
            if (!allAgents || allAgents.length === 0) dispatch(getAllAgents());
            if (!allPhones || allPhones.length === 0) dispatch(getAllPhones());
        }

        const { hash } = window.location;
        const hashPhoneId = hash.split('#')[1];
        if (hashPhoneId && hashPhoneId !== phoneId) {
            dispatch(setPhoneId(hashPhoneId));
        }
    }, []); // Empty array to run only once

    // Filter agents when data or search changes
    useEffect(() => {
        filterAgents()
    }, [filterAgents]);

    // Filter numbers when data or search changes
    useEffect(() => {
        filterNumbers()
    }, [filterNumbers]);

    // Handle phone selection
    useEffect(() => {
        if (!allPhones || allPhones.length === 0) return;

        if (phoneId) {
            // Only update selected phone if it's different
            const findPhone = allPhones.find(phone => phone['_id'] === phoneId);
            if (findPhone && selectedPhone['_id'] !== phoneId) {
                setSelectedPhone(findPhone);
                // Only update URL if it doesn't already match
                if (window.location.hash !== `#${phoneId}`) {
                    history.replace(`/phones#${phoneId}`);
                }
            }
        } else if (!window.location.hash && allPhones.length > 0) {
            // Set default phone only if none is selected
            const firstPhone = allPhones[0];
            history.replace(`/phones#${firstPhone['_id']}`);
            dispatch(setPhoneId(firstPhone['_id']));
            setSelectedPhone(firstPhone);
        }
    }, [allPhones, phoneId, selectedPhone['_id'], dispatch, history]); // Use selectedPhone ID instead of object

    const handleCreatePhone = () => dispatch(createPhone({
        newForm,
        successCallback: (data) => {
            history.replace(`/phones#${data['_id']}`);
            updateOpenState('isAddNumber'); // Close the modal after adding phone
        }
    }));
    const updateForm = (e) => setNewForm(prevState => ({ ...prevState, [e['target']['name']]: e['target']['value'] }))
    const selectAgent = async (agent, type) => {
        setAgentSearch('');
        setOpenState({ ...openState, inboundDropdown: false, outboundDropdown: false });

        let updatedPhone = {};
        if (type === 'inbound') updatedPhone = { ...selectedPhone, inboundAgentId: agent };
        else if (type === 'outbound') updatedPhone = { ...selectedPhone, outboundAgentId: agent };
        setSelectedPhone(updatedPhone);
        handleUpdatePhone(updatedPhone);
    };

    const handleOutboundCall = e => {
        if (!selectedPhone['outboundAgentId'] || !selectedPhone['outboundAgentId']['_id']) {
            updateOpenState('isAddNumber');
            return EventBus.publish('error', 'Please select a Outbound Agent First');
        }
        updateOpenState('outboundCall');
        dispatch(createOutboundCall({ agentId: selectedPhone['outboundAgentId']['_id'], phoneId, phoneNumber: newForm['outboundPhone'] }))
    }

    const handleDelete = async (e) => {
        e.stopPropagation();
        dispatch(deletePhone(phoneId));

        setDeleteNumber('');
        setSelectedPhone({});
        dispatch(setPhoneId(''));
        history.replace(`/phones`);
    }

    const handleUpdatePhone = (data) => {
        if (data) dispatch(updatePhone(data))
        else dispatch(updatePhone(selectedPhone))
    }

    const updateOpenState = (name) => setOpenState({ ...openState, [name]: !openState[name] })

    return (
        <div className='content account-tabs phone-number-tab'>
            <div className='allemails-area'>
                <div className='header-title-area'>
                    <div className='left-area'>
                        <h2>Phone Numbers</h2>
                    </div>
                    <div className='right-btn-area'>
                        {selectedPhone['_id'] && (
                            <>
                                <button className='btn-style-border' onClick={() => updateOpenState('outboundCall')}>
                                    <span className='fa fa-phone mr-2'></span>
                                    Make an outbound call
                                </button>
                                <button className='action-btn' onClick={() => setDeleteNumber(phoneId)}>
                                    <span className='fa fa-trash'></span>
                                </button>
                            </>
                        )}
                        <button className='btn-style-new' onClick={() => updateOpenState('isAddNumber')}>+ Add Phone</button>
                    </div>
                </div>
            </div>
            <div className='account-tab-inner'>
                <div className='left-area'>
                    <div className='tabs-box'>
                        <div className='tabs-box'>
                            <div className='tabs-email'>
                                {selectedPhone['_id'] &&
                                    <div className='searchbox'>
                                        <i className='icon'>
                                            <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                                <g clip-path='url(#clip0_224_579)'>
                                                    <path d='M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z' fill='#89868D' />
                                                </g>
                                                <defs> <clipPath id='clip0_224_579'> <rect width='18' height='18' fill='white' /> </clipPath> </defs>
                                            </svg>
                                        </i>
                                        <TextField
                                            fullWidth
                                            hiddenLabel
                                            size='small'
                                            name='searchNumber'
                                            variant='standard'
                                            placeholder='Search...'
                                            value={searchNumber}
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={(e) => setNumberSearch(e['target']['value'])}
                                        />
                                    </div>
                                }
                                <AppBar position='static'>
                                    <Tabs value={phoneId} onChange={(e, newValue) => dispatch(setPhoneId(newValue))} aria-label="phone-tabs">
                                        {filteredNumbers.map(phone => (<Tab value={phone['_id']} key={phone['_id']} label={phone['nickName'] || phone['phoneNumber']} />))}
                                    </Tabs>
                                </AppBar>
                            </div >
                        </div >
                    </div >
                </div >
                <div className='right-tabs-area'>
                    <div className='tabs-content'>
                        {selectedPhone['_id']
                            ? <TabPanel key={selectedPhone['_id']} value='phone-tab'>
                                <div className='phone-number-tab-inner'>
                                    <div className='phone-number-box'>
                                        <div className='title-area'>
                                            {openState['editAgent'] ?
                                                <>
                                                    <input
                                                        autoFocus
                                                        type='text'
                                                        name='nickName'
                                                        value={selectedPhone['nickName'] || ''}
                                                        style={{ height: '40px', padding: '10px' }}
                                                        onChange={(e) => setSelectedPhone({ ...selectedPhone, nickName: e['target']['value'] })}
                                                    />
                                                    <i className="fa fa-check title-edit" aria-hidden="true" onClick={() => { handleUpdatePhone(); updateOpenState('editAgent'); }} />
                                                </>
                                                :
                                                <>
                                                    <h4>{selectedPhone['nickName'] || selectedPhone['phoneNumber'] || ''} </h4>
                                                    <button className='title-edit' onClick={() => updateOpenState('editAgent')}>
                                                        <span className='icon fa fa-edit'></span>
                                                    </button>
                                                </>
                                            }
                                        </div >
                                        <h5><span>Number:</span> {selectedPhone['phoneNumber']}</h5>
                                    </div >
                                    <div className='inbounded-box'>
                                        <div className='group-from'>
                                            <h4>Inbound call agent</h4>
                                            <FormControl fullWidth>
                                                <Select
                                                    displayEmpty
                                                    open={openState['inboundDropdown']}
                                                    onOpen={() => updateOpenState('inboundDropdown')}
                                                    onClose={() => updateOpenState('inboundDropdown')}
                                                    value={selectedPhone['inboundAgentId'] || {}}
                                                    renderValue={(agent) => {
                                                        if (!agent['_id']) return 'Demo Calling Agent';
                                                        return (
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <i style={{ marginRight: '10px', marginTop: '-6px' }} className='fa fa-robot'></i>
                                                                <Typography sx={{ fontSize: '14px' }}>
                                                                    <p>{agent['name']} &nbsp; <span>{agent['type']}</span></p>
                                                                </Typography>
                                                            </Box>
                                                        );
                                                    }}
                                                >
                                                    <MenuItem disableRipple>
                                                        <TextField
                                                            fullWidth
                                                            autoFocus
                                                            value={searchAgent}
                                                            variant='standard'
                                                            placeholder='Search...'
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={(e) => setAgentSearch(e['target']['value'])}
                                                        />
                                                    </MenuItem>
                                                    {filteredAgents.length > 0 ?
                                                        <>
                                                            <MenuItem key={'none'} value={'none'} onClick={() => selectAgent(null, 'inbound')}>
                                                                <p>Select None</p>
                                                            </MenuItem>
                                                            {filteredAgents.map((agent) => (
                                                                <MenuItem key={agent['name']} value={agent['name']} onClick={() => selectAgent(agent, 'inbound')}>
                                                                    <i style={{ marginRight: '10px', marginTop: '-6px' }} className='fa fa-robot'></i> <p>{agent['name']} <span>{agent['type']}</span></p>
                                                                </MenuItem>
                                                            ))}
                                                        </>
                                                        : <MenuItem disabled>No results found</MenuItem>
                                                    }
                                                </Select >
                                            </FormControl >
                                        </div >

                                        <div className='group-from'>
                                            <h4>Outbound call agent</h4>
                                            <FormControl fullWidth>
                                                <Select
                                                    displayEmpty
                                                    open={openState['outboundDropdown']}
                                                    onOpen={() => updateOpenState('outboundDropdown')}
                                                    onClose={() => updateOpenState('outboundDropdown')}
                                                    value={selectedPhone['outboundAgentId'] || {}}
                                                    renderValue={(agent) => {
                                                        if (!agent['_id']) return 'Add Outbound Agent';
                                                        return (
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                <i style={{ marginRight: '10px', marginTop: '-6px' }} className='fa fa-robot'></i>
                                                                <Typography sx={{ fontSize: '14px' }}>
                                                                    <p>{agent['name']} &nbsp; <span>{agent['type']}</span></p>
                                                                </Typography>
                                                            </Box>
                                                        )
                                                    }}
                                                >
                                                    <MenuItem disableRipple>
                                                        <TextField
                                                            fullWidth
                                                            autoFocus
                                                            value={searchAgent}
                                                            variant='standard'
                                                            placeholder='Search...'
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={(e) => setAgentSearch(e['target']['value'])}
                                                        />
                                                    </MenuItem>
                                                    {filteredAgents.length > 0 ?
                                                        <>
                                                            <MenuItem key={'none'} value={'none'} onClick={() => selectAgent(null, 'outbound')}>
                                                                <p>Select None</p>
                                                            </MenuItem>
                                                            {filteredAgents.map((agent) => (
                                                                <MenuItem key={agent['name']} value={agent['name']} onClick={() => selectAgent(agent, 'outbound')}>
                                                                    <i style={{ marginRight: '10px', marginTop: '-6px' }} className='fa fa-robot'></i><p>{agent['name']} &nbsp; <span>{agent['type']}</span></p>
                                                                </MenuItem>
                                                            ))}
                                                        </>
                                                        : <MenuItem disabled>No results found</MenuItem>
                                                    }
                                                </Select >
                                            </FormControl >
                                        </div >
                                    </div >
                                </div >
                            </TabPanel >
                            : <TabPanel key={selectedPhone['_id']} value='phone-tab'>
                                <div className='phone-number-tab-inner not-found'>
                                    {loading ?
                                        <div style={{ padding: '40px', textAlign: 'center', display: 'flex', justifyContent: 'center' }}><PlanAnimation /></div>
                                        :
                                        <div className='notfound-area'>
                                            <div className='img-box'>
                                                <img alt="..." src={require('../../static/img/not-found.png')} />
                                            </div>
                                            <p>No Phone added</p>
                                        </div>
                                    }
                                </div>
                            </TabPanel>
                        }
                    </div >
                </div >
            </div >

            {/* Connect Your Number Modal */}
            <AddPhoneModal
                isOpen={openState['isAddNumber']}
                onClose={() => updateOpenState('isAddNumber')}
                onSave={form => { dispatch(createPhone({ newForm: form, successCallback: data => { history.replace(`/phones#${data['_id']}`); updateOpenState('isAddNumber'); } })); }}
            />

            {/* Outbound Call Modal */}
            < Modal isOpen={openState['outboundCall']} className={`main-modal new-user-modal modal-dialog-centered create-label-modal`}>
                <ModalHeader toggle={() => updateOpenState('outboundCall')}></ModalHeader>
                <ModalBody>
                    <div className='content-area'>
                        <h4>Make Outbound Call</h4>
                        <div className='form-area'>
                            <div className='group-form phone-group'>
                                <label>Phone</label>
                                <PhoneInput
                                    country='pk'
                                    // country='us'
                                    placeholder='Enter Phone Number'
                                    value={newForm['outboundPhone']}
                                    onChange={(value) => setNewForm({ ...newForm, outboundPhone: `+${value}` })}
                                />
                            </div>
                            <div className='text-box'>
                                <p>
                                    <i className='icon'>
                                        <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 12.75C9.2125 12.75 9.39075 12.678 9.53475 12.534C9.67875 12.39 9.7505 12.212 9.75 12V9C9.75 8.7875 9.678 8.6095 9.534 8.466C9.39 8.3225 9.212 8.2505 9 8.25C8.788 8.2495 8.61 8.3215 8.466 8.466C8.322 8.6105 8.25 8.7885 8.25 9V12C8.25 12.2125 8.322 12.3907 8.466 12.5347C8.61 12.6787 8.788 12.7505 9 12.75ZM9 6.75C9.2125 6.75 9.39075 6.678 9.53475 6.534C9.67875 6.39 9.7505 6.212 9.75 6C9.7495 5.788 9.6775 5.61 9.534 5.466C9.3905 5.322 9.2125 5.25 9 5.25C8.7875 5.25 8.6095 5.322 8.466 5.466C8.3225 5.61 8.2505 5.788 8.25 6C8.2495 6.212 8.3215 6.39025 8.466 6.53475C8.6105 6.67925 8.7885 6.751 9 6.75ZM9 16.5C7.9625 16.5 6.9875 16.303 6.075 15.909C5.1625 15.515 4.36875 14.9808 3.69375 14.3063C3.01875 13.6318 2.4845 12.838 2.091 11.925C1.6975 11.012 1.5005 10.037 1.5 9C1.4995 7.963 1.6965 6.988 2.091 6.075C2.4855 5.162 3.01975 4.36825 3.69375 3.69375C4.36775 3.01925 5.1615 2.485 6.075 2.091C6.9885 1.697 7.9635 1.5 9 1.5C10.0365 1.5 11.0115 1.697 11.925 2.091C12.8385 2.485 13.6323 3.01925 14.3063 3.69375C14.9803 4.36825 15.5148 5.162 15.9098 6.075C16.3048 6.988 16.5015 7.963 16.5 9C16.4985 10.037 16.3015 11.012 15.909 11.925C15.5165 12.838 14.9823 13.6318 14.3063 14.3063C13.6303 14.9808 12.8365 15.5152 11.925 15.9097C11.0135 16.3042 10.0385 16.501 9 16.5Z' fill='#4b5563' /></svg>
                                        <div className='toolbox-area'>
                                            <p>International calls are currently not supported.</p>
                                        </div>
                                    </i>
                                    <p>International calls are currently not supported.</p>
                                </p>
                            </div>

                            <div className='btns-box text-right'>
                                <button className='btn-style-border' onClick={() => updateOpenState('outboundCall')}><i className="fa fa-times mr-2" />Cancel</button>
                                <button className='btn-style-new' onClick={handleOutboundCall} ><i className="fa fa-phone mr-1" /> &nbsp; Make Call</button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal >

            {/* Buy New Modal */}
            < Modal isOpen={openState['buyNumber']} className={`main-modal new-user-modal modal-dialog-centered create-label-modal`}>
                <ModalHeader toggle={() => updateOpenState('buyNumber')}></ModalHeader>
                <ModalBody>
                    <div className='content-area'>
                        <h4>Buy Phone Number</h4>
                        <div className='form-area'>
                            <div className='group-form phone-group'>
                                <label>Area Code <span>(Optional)</span></label>
                                <PhoneInput
                                    name='phone'
                                    country='us'
                                    placeholder='e.g. 650'
                                // value={formData.phone}
                                />
                            </div>
                            <div className='text-box'>
                                <p>
                                    <i className='icon'>
                                        <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 12.75C9.2125 12.75 9.39075 12.678 9.53475 12.534C9.67875 12.39 9.7505 12.212 9.75 12V9C9.75 8.7875 9.678 8.6095 9.534 8.466C9.39 8.3225 9.212 8.2505 9 8.25C8.788 8.2495 8.61 8.3215 8.466 8.466C8.322 8.6105 8.25 8.7885 8.25 9V12C8.25 12.2125 8.322 12.3907 8.466 12.5347C8.61 12.6787 8.788 12.7505 9 12.75ZM9 6.75C9.2125 6.75 9.39075 6.678 9.53475 6.534C9.67875 6.39 9.7505 6.212 9.75 6C9.7495 5.788 9.6775 5.61 9.534 5.466C9.3905 5.322 9.2125 5.25 9 5.25C8.7875 5.25 8.6095 5.322 8.466 5.466C8.3225 5.61 8.2505 5.788 8.25 6C8.2495 6.212 8.3215 6.39025 8.466 6.53475C8.6105 6.67925 8.7885 6.751 9 6.75ZM9 16.5C7.9625 16.5 6.9875 16.303 6.075 15.909C5.1625 15.515 4.36875 14.9808 3.69375 14.3063C3.01875 13.6318 2.4845 12.838 2.091 11.925C1.6975 11.012 1.5005 10.037 1.5 9C1.4995 7.963 1.6965 6.988 2.091 6.075C2.4855 5.162 3.01975 4.36825 3.69375 3.69375C4.36775 3.01925 5.1615 2.485 6.075 2.091C6.9885 1.697 7.9635 1.5 9 1.5C10.0365 1.5 11.0115 1.697 11.925 2.091C12.8385 2.485 13.6323 3.01925 14.3063 3.69375C14.9803 4.36825 15.5148 5.162 15.9098 6.075C16.3048 6.988 16.5015 7.963 16.5 9C16.4985 10.037 16.3015 11.012 15.909 11.925C15.5165 12.838 14.9823 13.6318 14.3063 14.3063C13.6303 14.9808 12.8365 15.5152 11.925 15.9097C11.0135 16.3042 10.0385 16.501 9 16.5Z' fill='#4b5563' /></svg>
                                        <div className='toolbox-area'>
                                            <p>This number incurs a monthly fee of $2.00.</p>
                                        </div>
                                    </i>
                                    <p>This number incurs a monthly fee of $2.00.</p>
                                </p>
                            </div>

                            <div className='btns-box text-right'>
                                <button className='btn-style-new'>Save</button>
                                <button className='btn-style-border'>Cancel</button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal >

            {/* Delete Phone Number Modal */}
            < Modal isOpen={deleteNumber} className={`main-modal new-user-modal modal-dialog-centered create-label-modal`}>
                <ModalHeader toggle={() => setDeleteNumber('')}></ModalHeader>
                <ModalBody>
                    <div className='content-area'>
                        <div className='delete-modal'>
                            <h4>
                                <i className='icon'>
                                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path d='M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z' fill='#FF3B30' fill-opacity='0.15' />
                                        <path d='M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5Z' fill='#FF3B30' />
                                        <path d='M12 9V12' stroke='#FFE2E0' strokeWidth='2' stroke-linecap='round' stroke-linejoin='round' />
                                        <path d='M12 15H12.0083' stroke='#FFE2E0' strokeWidth='2' stroke-linecap='round' stroke-linejoin='round' />
                                    </svg>
                                </i>
                                Delete Phone
                            </h4>
                            <p>Are your sure you want to delete this phone?</p>
                            <div className='form-area'>
                                <div className='btns-box text-right'>
                                    <button className='btn-style-border' onClick={() => setDeleteNumber('')}>Cancel</button>
                                    <button className='btn-style-new' onClick={handleDelete} >Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal >
        </div >
    )
}
function TabPanel(props) {
    const { children, value, key, ...other } = props;
    return (
        <div role='tabpanel' key={key} id={`simple-tabpanel-${key}`} aria-labelledby={`simple-tab-${key}`}{...other}>
            {children && <Box p={3}> <Typography>{children}</Typography> </Box>}
        </div>
    )
}
TabPanel.propTypes = { children: PropTypes['node'], index: PropTypes['any']['isRequired'], value: PropTypes['any']['isRequired'] }

export default PhoneNumbers;
